import React from 'react';
import styled from 'styled-components';
import CardIconBG from '../../assets/img/CoinIconBgDarker.png'

interface CardIconProps {
  children?: React.ReactNode;
}

interface StyledCardIconProps {
  children?: React.ReactNode;
}

const StyledCardIcon = styled.div<StyledCardIconProps>`
  background: url('${CardIconBG}');
  background-size: contain;
  background-repeat: no-repeat;
  font-size: 36px;
  height: 95px;
  width: 95px;
  border-radius: 40px;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 auto ${(props) => props.theme.spacing[3]}px;
`;

const CardIcon = ({ children }: CardIconProps) => {
  const hasChildren = React.Children.count(children) > 0;
  
  return (
    <div className='relative w-80 h-80 rounded-full transition-colors duration-200 flex items-center justify-center bg-secondary'>
      <div tabIndex={0} style={{ transform: "none"}}>  
        <div style={{transformStyle: "preserve-3d", transform: "none"}}>
        <div style={{ 
            color: 'rgb(115, 115, 115)',
            backgroundColor: 'rgba(115, 115, 115, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px'
        }}>
            {hasChildren ? <>{children}</> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

CardIcon.defaultProps = {
  children: null,
};

export default CardIcon;
